const ADDITIONAL_SERVICES = [
	{ code: 'crm', name: 'CRM', description: 'Gestión comercial y seguimiento de clientes.', icon: 'contacts' },
	{ code: 'deuna', name: 'Deuna', description: 'Cobros y pagos mediante la integración Deuna.', icon: 'account_balance_wallet' },
	{ code: 'cashback', name: 'Cashback', description: 'Devolución de un porcentaje de las compras a los clientes.', icon: 'redeem' },
	{ code: 'whatsapp', name: 'WhatsApp', description: 'Comunicación y envío de mensajes por WhatsApp.', icon: 'chat' },
	{ code: 'push_notifications', name: 'Notificaciones push', description: 'Avisos enviados directamente a dispositivos.', icon: 'notifications_active' },
];

function toFeatureBoolean(value) {
	if (typeof value === 'string') return !['', '0', 'false', 'null'].includes(value.toLowerCase());
	return Boolean(value);
}

function parseAdditionalServices(plan) {
	const source = (plan || {}).additional_services;
	if (typeof source === 'string') {
		try {
			const parsed = JSON.parse(source);
			return parsed && typeof parsed === 'object' ? parsed : {};
		} catch (error) {
			return {};
		}
	}
	return source && typeof source === 'object' ? source : {};
}

function humanizeServiceCode(code) {
	const text = String(code).replace(/[_-]+/g, ' ').trim();
	return text.charAt(0).toUpperCase() + text.slice(1);
}

function additionalServiceDefinition(code) {
	return ADDITIONAL_SERVICES.find(service => service.code === code) ||
		{ code, name: humanizeServiceCode(code), description: 'Función adicional del plan.', icon: 'extension' };
}

function additionalServiceCodes(plan) {
	const stored = Object.keys(parseAdditionalServices(plan));
	const catalog = ADDITIONAL_SERVICES.map(service => service.code);
	return catalog.concat(stored.filter(code => !catalog.includes(code)));
}

export {
	ADDITIONAL_SERVICES,
	additionalServiceCodes,
	additionalServiceDefinition,
	parseAdditionalServices,
	toFeatureBoolean,
};



// WEBPACK FOOTER //
// ./src/shared/plan-features.js